/*
 * @Description: 
 * @Version: 
 * @Autor: houcf
 * @Date: 2023-02-23 15:02:31
 * @LastEditTime: 2023-03-07 11:55:15
 */
import http from '../plugins/utils/http'
let api = '/api'
const news = {
    newsListApi(params) {
        return http.post(`${api}/app-jycy-consultation/getPageListByType`, params)
    },
    updataReadApi(params) {
        return http.get(`${api}/app-jycy-consultation/ConsultationService/updataRead`, params)
    },
    getDetailApi(params) {
        return http.get(`${api}/app-jycy-consultation/ConsultationService/getDetail`, params)
    },
    //首页新闻信息
    getConsulationListApi(params) {
        return http.get(`${api}/app-jycy-consultation/getConsulationList`, params)
    },
    getDeptApi(params) {
        return http.get(`${api}/app-jycy-hebei/getDept`, params)
    },

}
export default news
